'use client'

import { usePathname } from 'next/navigation'
import NextLink from 'next/link'

import { ElectionMetaResponseVo } from '@schemas/non-auth'
import { useSendElectionBanner } from '@hooks/ga4/election'

import PromotionBanner from './PromotionBanner'
import BallotBanner from './BallotBanner'
import PredictiveBanner from './PredictiveBanner'
import VoteBanner from './VoteBanner'
import ResultBanner from './ResultBanner'

interface TopBannerProps {
	data: ElectionMetaResponseVo
	viewPoint: string
}

const BANNER_COMPONENTS = {
	promotionBanner: PromotionBanner,
	ballotBanner: BallotBanner,
	predictiveBanner: PredictiveBanner,
	voteBanner: VoteBanner,
	resultBanner: ResultBanner,
} as const

const TopBanner = ({ data, viewPoint }: TopBannerProps) => {
	const pathname = usePathname()
	const { sendElectionBanner } = useSendElectionBanner()

	const setGA4 = () => {
		if (viewPoint === 'home') {
			if (pathname.includes('article')) {
				sendElectionBanner('article_banner_topic', { btn: '프로모션배너' })
			} else {
				sendElectionBanner('home_banner', { btn: '프로모션배너' })
			}
		} else if (viewPoint === 'article') {
			sendElectionBanner('article_banner_issue', { btn: '프로모션배너' })
		} else if (viewPoint === 'election') {
			sendElectionBanner('topic_banner_issue', { btn: '프로모션배너' })
		}
	}

	if (data.topBannerYn !== 'Y') return null

	const bannerType = data.topBannerType
	const BannerComponent = BANNER_COMPONENTS[bannerType as keyof typeof BANNER_COMPONENTS]

	return (
		<NextLink href={data.topBannerLinkUrl} onClick={setGA4}>
			<BannerComponent data={data} viewPoint={viewPoint} />
		</NextLink>
	)
}

export default TopBanner
